/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// prop-types is a library for typechecking of props
import PropTypes from 'prop-types';

// Soft UI Dashboard PRO React components
import SoftBox from 'components/SoftBox';
import SoftTypography from 'components/SoftTypography';
import SoftAvatar from 'components/SoftAvatar';

function CustomerCell({ image, name, color }) {
    return (
        <SoftBox display="flex" alignItems="center">
            <SoftBox mr={1}>
                <SoftAvatar bgColor={color} src={image} alt={name} size="xs" />
            </SoftBox>
            <SoftTypography
                variant="caption"
                fontWeight="medium"
                color="text"
                sx={{ lineHeight: 0 }}
            >
                {name}
            </SoftTypography>
        </SoftBox>
    );
}

// Setting default value for the props of CustomerCell
CustomerCell.defaultProps = {
    image: '',
    color: 'dark',
};

// Typechecking props for the CustomerCell
CustomerCell.propTypes = {
    image: PropTypes.string,
    name: PropTypes.string.isRequired,
    color: PropTypes.oneOf([
        'transparent',
        'primary',
        'secondary',
        'info',
        'success',
        'warning',
        'error',
        'light',
        'dark',
    ]),
};

export default CustomerCell;
